import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDivider: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDivider"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H6V6H2V4ZM2 4H6V6H2V4ZM2 4H6V6H2V4ZM2 4H6V6H2V4ZM2 4H6V6H2V4ZM2 4H6V6H2V4ZM2 4H6V6H2V4Z" fill="currentColor"/><Path d="M14 4V6H10V4H14Z" fill="currentColor"/><Path d="M22 4V6H18V4H22Z" fill="currentColor"/><Path d="M22 11V13H2V11H22Z" fill="currentColor"/><Path d="M6 18V20H2V18H6Z" fill="currentColor"/><Path d="M14 18V20H10V18H14Z" fill="currentColor"/><Path d="M22 18V20H18V18H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDivider;
